import brandsPdvend from "./pdvend";
import brandsMhi from "./mhi";

const envToBrandsMap = {
  PDVEND: brandsPdvend,
  MHI: brandsMhi
};

const brands = envToBrandsMap[process.env.REACT_APP_WHITELABEL_NAME];

export default brands;



// WEBPACK FOOTER //
// ./src/assets/brands/png/index.js